// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as SendSMSAssetsManager from "../../assets/SendSMSAssetsManager.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";

var open_in_new_icon = SendSMSAssetsManager.getImage("open-in-new-icon.svg");

function OpenTemplateManagerCmp(Props) {
  var onOpenTemplateManagerClick = Props.onOpenTemplateManagerClick;
  return React.createElement("div", {
              className: "template-manager-btn"
            }, React.createElement(PrimaryButton$Catalyst.make, {
                  buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                        TAG: /* Custom */1,
                        _0: (function (param) {
                            return React.createElement(React.Fragment, undefined, React.createElement("img", {
                                            src: open_in_new_icon
                                          }), React.createElement("p", undefined, "Open Template Manager"));
                          })
                      }, undefined, (function (_event) {
                          return Curry._1(onOpenTemplateManagerClick, undefined);
                        }), undefined, undefined, undefined, undefined, undefined, undefined, undefined)
                }));
}

var make = OpenTemplateManagerCmp;

export {
  open_in_new_icon ,
  make ,
  
}
/* open_in_new_icon Not a pure module */
